<template>
    <div class="dataList">
        <pull :pull="pull" :page="page" @getList="getList">
            <noDataList v-if="!tableData.length">当前暂无资料</noDataList>
            <div class="m-list" v-else>
                <div class="box" v-for="(obj, index) in tableData" :key="index" @click="download(obj)">
                    <div class="left text-ellipse">{{obj.docname}}</div>
                    <div class="right">
                        <van-button type="primary" v-if="item.isjoin">下载</van-button>
                        <!--<a :href="obj.filekeyurl" :download="obj.docname">下载</a>-->
                    </div>
                </div>
            </div>
        </Pull>
    </div>
</template>

<script>
  import Pull from 'views/mobile/components/pull/pull'
  import {getCourseDocList, download} from 'api/api'
  import {mapActions, mapGetters} from 'vuex'
  import NoDataList from 'views/mobile/components/noData/noDataList'
  export default {
    name: 'dataList',
    props: ['item'],
    data() {
      return {
        param: {
          courseid: this.$route.query.cid ? this.$route.query.cid : '',
          ispage: 1 // 0 不分页 1 分页
        },
        page: {
          page: 1,
          pagesize: 10,
          pageCount: 2,
          rowCount: 0
        },
        pull: {
          isLoading: false,
          loading: false,
          error: false,
          finished: false
        },
        tableData: [],
        isRefresh: false,
        isjoin: 0
      }
    },
    mounted() {
    },
    methods: {
      init() {
        if ((this.item.isjoin && this.isRefresh ) || !this.tableData.length) {
          this.isRefresh = false
          this.getList()
        }
      },
      download(obj) {
        if (!this.isjoin) return false
        this.setLoading(true)
        download({
          data: {innerid: obj.innerid},
          name: obj.orgfilename,
          success: () => {
            this.setLoading(false)
            this.$toast.success('下载成功')
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      getList() {
        this.setLoading(true)
        getCourseDocList({
          data: Object.assign({}, this.param, this.page),
          success: data => {
            this.isjoin = data.data.isjoin
            if (!this.isjoin) {
              this.isRefresh = true
            }
            if (this.page.page === 1) {
              this.pull.isLoading = false
              this.tableData = data.data.content
            } else {
              this.tableData = this.tableData.concat(data.data.content)
            }
            this.setLoading(false)
            this.pull.loading = false
            this.page.pageCount = data.data.pageinfo.pageCount
            this.page.rowCount = data.data.pageinfo.rowCount
            if (this.page.page === this.page.pageCount) {
              this.pull.finished = true
            }
          },
          error: data => {
            this.setLoading(false)
            this.pull.error = true
            this.pull.loading = false
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters(['refresh'])
    },
    components: {
      Pull, NoDataList
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .dataList {
        .m-list{
            .box{
                display: flex;
                align-items: center;
                height: 1rem;
                font-size: 0.28rem;
                color: #303133;
                padding: 0 0.32rem;
                box-sizing: border-box;
                background: #fff;
                .left{
                    line-height: 0.4rem;
                    flex-grow: 1;
                }
                .right{
                    margin-left: 0.2rem;
                    .van-button{
                        width: 1rem;
                        height: 0.5rem;
                        line-height: 0.48rem;
                        background: #fff;
                        border: 0.01rem solid #409EFF;
                        color: #409EFF;
                        border-radius: 0.22rem;
                        font-size: 0.22rem;
                        text-align: center;
                        padding: 0;
                        box-sizing: border-box;
                    }
                }
            }
            .box+ .box{
                border-top: 0.01rem solid #E5E5E5;
            }
        }
        .noData{
            padding: 2rem 0;
        }
    }
</style>